<template>
  <div>
    <v-row>
      <v-col cols="12 py-0">
        <v-card>
          <v-container fluid>
            <!-- Filters -->
            <v-row class="ma-0 align-right">
              <v-col cols="12" sm="6" lg="9" md="6" class=""> </v-col>
              <v-col
                cols="12"
                sm="6"
                lg="3"
                md="6"
                class="px-0 d-flex justify-space-between"
              >
                <v-combobox
                  hide-details="auto"
                  hide-no-data
                  v-model="selectedProduct"
                  @change="searchProduct = ''"
                  @input="GetProducts(searchProduct)"
                  :items="ProductsData"
                  clearable
                  :search-input.sync="searchProduct"
                  outlined
                  item-text="name"
                  item-value="id"
                  label="Select Product"
                  multiple
                  small-chips
                >
                </v-combobox>
                <v-btn
                  depressed
                  small
                  height="32"
                  class="btn_blue w-100 ml-2"
                  @click="AssignShopToProduct()"
                >
                  update
                </v-btn>
              </v-col>
            </v-row>

            <v-row class="ma-0 align-right sub-section">
              <TableFilters
                :filters="['search']"
                v-model="filter"
                :columns="columns"
                :msgs="'Reference Number/Name'"
              ></TableFilters>
            </v-row>
            <v-row>
              <v-col cols="12 textbold">
                <v-data-table
                  :items-per-page="paginationOptions.perPage"
                  :headers="columns"
                  :items="ShopProductsData"
                  item-key="id"
                  hide-default-footer
                  @click:row="$router.push(`/product/${$event.id}`)"
                  class="row-pointer"
                  style="font-weight: bold"
                >
                  <!--  -->
                  <!-- No -->
                  <template v-slot:item.no>
                    <v-icon>mdi-vuetify</v-icon>
                  </template>

                  <!-- Status
                  <template v-slot:item.status="{ item }">
                    <v-chip
                      :x-small="true"
                      class="ma-2"
                      label
                      text-color="white"
                      :color="getStatusColor(item.is_active)"
                      dark
                      >{{ item.is_active  == true ? "Active":"Archieve" }}
                    </v-chip>
                  </template> -->

                  <!-- Action -->
                  <template v-slot:item.action="{ item }">
                    <v-menu offset-y transition="scroll-y-transition">
                      <template v-slot:activator="{ attrs, on }">
                        <v-icon v-bind="attrs" v-on="on"
                          >mdi-dots-vertical
                        </v-icon>
                      </template>
                      <v-list class="actions">
                        <v-list-item @click="openConfirmation(item)">
                          <span>
                            <v-icon v-bind="attrs" v-on="on">mdi-archive</v-icon
                            >Remove
                          </span>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                </v-data-table>
                <paginationComponent
                  @paginationOptions="setPaginationOptions"
                  :url="`shops/${$route.params.id}/products`"
                  @response="receiveShopsResponse"
                  ref="shopdetails"
                  :paginationAction="false"
                  :filter="filter"
                />
              </v-col>
            </v-row>
            <!-- Data table -->

            <v-row> </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <!-- </v-container> -->
  </div>
</template>
<script>
import _ from 'lodash';
import { SupplierListViewModel } from '@/models/View Models/Supplier';
import confirmation from '../../../components/confirmation';
import TableFilters from '@/components/base/TableFilters';
import paginationComponent from '../../../components/pagination';

export default {
  data: () => ({
    paginationOptions: {},
    searchProduct: null,
    selectedProduct: [],
    ProductsData: [],

    columns: [
      {
        text: 'Reference Number',
        value: 'reference_number',
        show: true,
        disabled: false,
        align: 'left',
      },
      {
        text: 'Name',
        value: 'name',
        show: true,
        disabled: false,
        align: 'left',
      },
      {
        text: 'Code',
        value: 'code',
        show: true,
        disabled: false,
        align: 'left',
      },
      {
        text: 'Category',
        value: 'category.name',
        show: true,
        disabled: false,
        align: 'left',
      },
      {
        text: 'Brand',
        value: 'brand.name',
        show: true,
        disabled: false,
        align: 'left',
      },
      {
        text: 'Min Price',
        value: 'min_price',
        show: true,
        disabled: false,
        align: 'center',
      },
      {
        text: 'Actions',
        value: 'action',
        show: true,
        disabled: false,
        align: 'center',
      },
    ],
    filter: {
      search: '',
    },
    date_range: [],
    ShopProductsData: [],
    productDetails: [],
  }),
  props: {
    module: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
  },
  components: { paginationComponent, TableFilters },
  created() {},
  computed: {
    dateRangeText() {
      this.filter.start = this.date_range[0];
      this.filter.end = this.date_range[1];
      return this.date_range.join(' ~ ');
    },
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  watch: {
    searchProduct(value) {
      if (!value) {
        this.GetProducts('');
      }
      this.GetProducts(value);
    },
  },

  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    refreshData() {
      this.$refs.shopdetails.refreshData();
    },
    async AssignShopToProduct() {
      let credentials = new Object();
      credentials.products = [];
      this.selectedProduct.map((p) => {
        credentials.products.push(p.id);
      });
      credentials.shopId = this.$route.params.id;
      this.AssignProduct(credentials);
    },
    AssignProduct(credentials) {
      this.$store
        .dispatch(`product/AssignProductToShops`, credentials)
        .then((res) => {
          this.refreshData();
          this.selectedProduct = null;
          this.isLoading = false;
          this.$toast.success('Product assigned successfully');
        })
        .catch((err) => {
          this.isLoading = false;
          this.$toast.error('Failed to assign product ');

          //   this.payment = new Payment();
        });
    },
    openConfirmation(item) {
      confirmation.dialog = true;

      this.$confirm('Do you want to Remove ?').then((res) => {
        if (res) {
          this.removeShop(item);
        }
      });
    },
    async removeShop(item) {
      const credentials = new Object();
      credentials.products = [item.id];
      credentials.shopId = this.$route.params.id;

      this.removeShopFromProduct(credentials);
    },

    removeShopFromProduct(credentials) {
      this.$store
        .dispatch(`product/RemoveProductFromShops`, credentials)
        .then((res) => {
          this.refreshData();
          if (this.ShopProductsData) {
            let index = this.ShopProductsData.findIndex(
              (p) => p.id == credentials.products[0],
            );
            if (index != -1) {
              this.ShopProductsData.splice(index, 1);
            }
          }
          this.$toast.success('Product removed successfully');

          this.selectedProduct = [];
          this.GetProducts();

          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$toast.error('Failed to remove product');
          //   this.payment = new Payment();
        });
    },

    getStatusColor(status) {
      return status == true ? 'green' : 'gray';
    },
    receiveShopsResponse(data) {
      this.ShopProductsData = data;
      this.GetProducts();
    },

    GetProducts(query = '') {
      this.searchProduct = null;
      let except = [];
      this.ShopProductsData.forEach((products) => {
        except.push(products.id);
      });
      if (this.selectedProduct && this.selectedProduct.length > 0) {
        this.selectedProduct.forEach((products) => {
          except.push(products.id);
        });
      }
      this.$store
        .dispatch('product/GetProduct', {
          query: query,
          except: except,
        })
        .then((res) => {
          this.ProductsData = res;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
  },
};
</script>

<style scoped>
.textbold {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
</style>
